import React, { Dispatch, SetStateAction } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftToLine } from '@fortawesome/pro-regular-svg-icons';
import NSSearchBar from 'bricks/NSSearchBar/NSSearchBar';
import { NSButton } from 'bricks';
import { VIEW_ENTITY } from 'views/ProFormaTable/constants';
import classNames from 'classnames';

interface ImportSearchBarProps {
    onExitImport: () => void;
    searchValue: string
    setSearchValue: Dispatch<SetStateAction<string>>;
    onToggleView: (view: VIEW_ENTITY) => void;
    view: VIEW_ENTITY;
}

const ImportSearchBar: React.FC<ImportSearchBarProps> = ({
    onExitImport,
    searchValue,
    setSearchValue,
    onToggleView,
    view,
}) => {
    const handleToggleSelection = (newView: VIEW_ENTITY) => {
        onToggleView(newView);
        setSearchValue('');
    };

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setSearchValue(newValue);
    };

    const searchPlaceholder = view === 'deals' ? 'Search deals' : 'Search projects';

    return (
        <>
            <div className="text-primary cursor--pointer pb-1" role="presentation" onClick={onExitImport}>
                <FontAwesomeIcon icon={faArrowLeftToLine} className="ml-1 my-auto text-primary pr-1" />
                Exit
            </div>
            <div className="d-flex flex-row w-100 mb-2">
                <NSSearchBar
                    containerClassName="mb-0 flex-grow-1"
                    searchValue={searchValue}
                    placeholder={searchPlaceholder}
                    handleChangeSearchValue={handleSearch}
                    id="report-options"
                />
                <div className="pl-1 my-auto font-weight-normal text-dark text-nowrap">
                    <NSButton
                        color="secondary"
                        outline={false}
                        text="Deals"
                        className={classNames('px-3', { 'border border-primary bg-primary-lighten': view === VIEW_ENTITY.DEALS })}
                        callback={() => handleToggleSelection(VIEW_ENTITY.DEALS)}

                    />
                    <NSButton
                        color="secondary"
                        outline={false}
                        text="Projects"
                        className={classNames('px-3', {
                            'border border-primary bg-primary-lighten': view === VIEW_ENTITY.PROJECTS,
                        })}
                        callback={() => handleToggleSelection(VIEW_ENTITY.PROJECTS)}
                    />
                </div>
            </div>
        </>
    );
};

export default ImportSearchBar;
